import React from 'react'
import { Box, Stack } from '@mui/material'
import { Paper } from '@e3dc-react/shell/Elements/Paper'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { useUser } from 'src/Hooks/useUser'
import CompanyInstallers from '../components/CompanyInstallers'
import { useCompanyInstallersHelper } from 'src/Libs/company-settings/hooks/use-company-installers-helper'

type Props = {
  companyId: number
}

/**
 * The component does provide the actual content for the company permissions editor.
 * It can only be used if its dependencies (company, user data) are available.
 *
 * The component has to consider the following special conditions:
 * - the table content is a composition of multiple data source on the horizontal and vertical levels
 * - the vertical data is composed out of open invitations and assigned accounts
 * - the horizontal for assigned users is composed of the actual user and additional provided information about available error notifications
 * - updating the error notification settings is an instant update, and the reference id changes with every update
 *
 * @constructor
 */
const CompanyPermissions: React.VFC<Props> = ({ companyId }) => {
  const { userData } = useUser()
  const { t } = useCustomTranslation()
  const { handleChangeNotifications, tableItems, installersLoading, invitesLoading } = useCompanyInstallersHelper(companyId, userData)

  return (
    <Stack spacing={2}>
      <Paper title={t('user.company.accessRights')}>
        <Box sx={{ pl: 3, pr: 3 }}>
          <CompanyInstallers
            installers={tableItems}
            loading={installersLoading || invitesLoading}
            companyId={companyId}
            onChangeNotifications={handleChangeNotifications}
          />
        </Box>
      </Paper>
    </Stack>
  )
}

export default CompanyPermissions
